// extracted by mini-css-extract-plugin
export var button = "_c1-0";
export var icon = "_c1-1";